import React, { useEffect, useState } from "react";
import { TableContainer, Paper, Button } from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import getNameByID from "../../../../functions/getNameByID";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import SearchSetInvoices from "../../../components/Search/SearchSetInvoices";
import { Get_Invoices_Fuzzy_Search } from "../api/Get_Invoices_Fuzzy_Search";

// material-ui

function ViewInvoices() {
  const { logout } = StaffuseAuth();

  const [Invoices, setInvoices] = useState([]);

  useEffect(() => {
    Get_Invoices_Fuzzy_Search(
      "Invoices",
      "Xero_2025",
      {
        InvoiceNumber: "",
        Staff_id: "",
        Paid_Status: "UnPaid",
        DueAfter: "",
        DueBefore: "",
      },
      Number(10000),
      setInvoices,
      { Due_Date: 1 },
      {},
      logout
    );
  }, []);

  const [Staff, setStaff] = useState([]);

  useEffect(() => {
    Get_All_From_MongoDB("Staff", "Users", setStaff, logout);
  }, []);

  console.log(Invoices);

  function GetTotalOfSubAmounts(Invoice) {
    let Total = 0;
    Invoice.Attendees?.forEach((Attendee) => {
      //Total += Attendee.SubAmount;
      Total += Number(Attendee.SubAmount);
    });
    return Total;
  }

  const emojis = ["😢", "😠", "😲", "😭", "😡", "😱"];
  function getRandomEmoji() {
    const randomIndex = Math.floor(Math.random() * emojis.length);
    return emojis[randomIndex];
  }

  function isFullAmountAssigned(Invoice){
     return Number(GetTotalOfSubAmounts(Invoice)) !==
                          Number(Invoice.Amount)
  }

  let InvoicesFiltered = Invoices.filter((Invoice) => {
    return (
      isFullAmountAssigned(Invoice)
    )
  })

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Invoices</h1>
        <h2>View All Invoices</h2>
        <DisplayExport excelData={Invoices} fileName="Invoices" />
        <SearchSetInvoices setInvoices={setInvoices} />
        <br></br>
        <br></br>
        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {SimpleTableCell("ID")}
                  {SimpleTableCell("Date")}
                  {SimpleTableCell("Invoice Number")}
                  {SimpleTableCell("Total Amount")}
                  {SimpleTableCell("Status")}
                  {SimpleTableCell("Create Date")}
                  {SimpleTableCell("Deadline")}
                  {SimpleTableCell("Created By")}
                  {SimpleTableCell("GO To")}
                </TableRow>
              </TableHead>
              <TableBody>
                {Invoices && Array.isArray(Invoices) ? (
                  Invoices.map((Invoice, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                          "& .MuiTableCell-root": {
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word", // Adjust padding here to make cells smaller
                          },
                        },
                        backgroundColor:
                          isFullAmountAssigned(Invoice) 
                          // Number(GetTotalOfSubAmounts(Invoice)) !==
                          // Number(Invoice.Amount)
                            ? "rgba(169, 20, 20, 0.2)"
                            : "inherit",
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {Invoice._id}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {Invoice.DateTime}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {Invoice.Invoice_Number}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {Invoice.Amount}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {Invoice.Paid_Status}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {Invoice.Paid_Date}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          backgroundColor:
                            //If today > Due_Date, then red, else green
                            new Date(Invoice.Due_Date) < new Date() &&
                            Invoice.Paid_Status !== "Paid" &&
                            Invoice.Paid_Status !== "Credited"
                              ? "rgba(159, 90, 253, 0.5)"
                              : "",
                        }}
                      >
                        {Invoice.Due_Date}
                        {new Date(Invoice.Due_Date) < new Date() &&
                        Invoice.Paid_Status !== "Paid" &&
                        Invoice.Paid_Status !== "Credited" ? (
                          <span style={{ fontSize: "1.5em" }}>
                            {" "}
                            {getRandomEmoji()}
                          </span>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {getNameByID(Staff, Invoice.Staff_id, "Username")}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        <Link
                          to={`/Staff/ViewInvoice/${Invoice._id}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <button>View</button>
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
        <div style={{ marginTop: "20px" }}></div>
      </section>
    </div>
  );
}

export default ViewInvoices;
